'use es6';

import BaseLoginDao from './BaseLoginDao';
import http from 'hub-http/clients/noAuthApiClient';

class LoginDao extends BaseLoginDao {
  googleLogin(credentials, lb) {
    return this.loginAtPath('/login-api/v1/google', credentials, lb);
  }

  uiLogin(credentials, lb) {
    return this.loginAtPath('/login-api/v1/login?src=ui', credentials, lb);
  }

  userTrustTokenLogin(credentials, lb) {
    return this.loginAtPath('/login-api/v1/login/trust-token', credentials, lb);
  }

  hubUserTrustTokenLogin(credentials, lb) {
    return this.loginAtPath('/login-api/v1/login/trust-token/hub-user', credentials, lb);
  }

  getLoginRequirement(data) {
    return http.post(`/login-api/v1/login-requirements`, {
      data: {
        email: data.email
      }
    });
  }

  getLoginRequirementWithPortal(data, queryData) {
    return http.post(`/login-api/v1/login-requirements/portal-id/${queryData.loginPortalId}`, {
      data: {
        email: data.email
      }
    });
  }

}

export default LoginDao;